import React, { useState, useEffect, useRef } from 'react';
import './UserMenu.css';

interface User {
  userId?: string;
  email: string;
  name: string;
  companyId?: string;
  role?: string;
}

interface UserMenuProps {
  className?: string;
}

const UserMenu: React.FC<UserMenuProps> = ({ className = '' }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Get user info from token
    const token = localStorage.getItem('dashzap_token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUser({
          userId: payload.userId,
          email: payload.email,
          name: payload.name,
          companyId: payload.companyId,
          role: payload.role
        });
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
  }, []);

  useEffect(() => {
    // Close menu when clicking outside
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    // Clear all localStorage items to ensure clean logout
    localStorage.clear();

    // Navigate to the root domain
    const currentOrigin = window.location.origin;
    window.location.href = currentOrigin;
  };

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(part => part.charAt(0).toUpperCase())
      .slice(0, 2)
      .join('');
  };

  if (!user) {
    return null;
  }

  return (
    <div className={`user-menu ${className}`} ref={menuRef}>
      <button
        className="user-avatar"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="User menu"
      >
        <div className="avatar-circle">
          {getInitials(user.name)}
        </div>
      </button>

      {isOpen && (
        <div className="user-dropdown">
          <div className="user-info">
            <div className="user-name">{user.name}</div>
            <div className="user-email">{user.email}</div>
            {user.role && (
              <div className="user-role">{user.role}</div>
            )}
          </div>
          <div className="dropdown-divider" />
          <button
            className="dropdown-item logout-btn"
            onClick={handleLogout}
          >
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;